import { jsx as _jsx } from "react/jsx-runtime";
import { extendCommonGroupsStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../../contexts";
const GroupList = (param)=>{
    let { children } = param;
    const { GroupList } = useStylesheet().extend(...extendCommonGroupsStylesheet);
    return /*#__PURE__*/ _jsx(GroupList, {
        children: children
    });
};
export { GroupList };
